import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberToWords'
})
export class NumToWordPipe implements PipeTransform {
  private readonly a = [
    '',
    'one ',
    'two ',
    'three ',
    'four ',
    'five ',
    'six ',
    'seven ',
    'eight ',
    'nine ',
    'ten ',
    'eleven ',
    'twelve ',
    'thirteen ',
    'fourteen ',
    'fifteen ',
    'sixteen ',
    'seventeen ',
    'eighteen ',
    'nineteen '
  ];

  private readonly b = [
    '',
    '',
    'twenty ',
    'thirty ',
    'forty ',
    'fifty ',
    'sixty ',
    'seventy ',
    'eighty ',
    'ninety '
  ];

  transform(value: any): string {
    if (value === null || value === undefined || value === '') return '';

    const num = Number(value);
    if (isNaN(num)) return '';

    const [rupeesPart, paisePart] = num.toFixed(2).split('.');

    const rupeesText = this.convertToWords(parseInt(rupeesPart));
    const paiseText = paisePart && parseInt(paisePart) > 0
      ? this.convertToWords(parseInt(paisePart)) + 'paise'
      : '';

    let result = '';
    if (rupeesText) {
      result += rupeesText + 'rupees';
    }
    if (paiseText) {
      result += ' and ' + paiseText;
    }

    return result.trim();
  }

  private convertToWords(num: number): string {
    if (num === 0) return 'zero ';
    if (num.toString().length > 9) return 'Amount too large';

    const n = ('000000000' + num)
      .slice(-9)
      .match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);

    if (!n) return '';

    let str = '';
    str += Number(n[1]) !== 0
      ? (this.a[Number(n[1])] || this.b[n[1][0]] + ' ' + this.a[n[1][1]]) + 'crore '
      : '';
    str += Number(n[2]) !== 0
      ? (this.a[Number(n[2])] || this.b[n[2][0]] + ' ' + this.a[n[2][1]]) + 'lakh '
      : '';
    str += Number(n[3]) !== 0
      ? (this.a[Number(n[3])] || this.b[n[3][0]] + ' ' + this.a[n[3][1]]) + 'thousand '
      : '';
    str += Number(n[4]) !== 0
      ? (this.a[Number(n[4])] || this.b[n[4][0]] + ' ' + this.a[n[4][1]]) + 'hundred '
      : '';
    str += Number(n[5]) !== 0
      ? ((str !== '') ? 'and ' : '') +
      (this.a[Number(n[5])] || this.b[n[5][0]] + ' ' + this.a[n[5][1]])
      : '';
    return str;
  }
}
